//
// Copyright 2023 DXOS.org
//
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
/**
 * Describes the file dxos/echo/indexing.proto.
 */
export const file_dxos_echo_indexing = /*@__PURE__*/ fileDesc("ChhkeG9zL2VjaG8vaW5kZXhpbmcucHJvdG8SEmR4b3MuZWNoby5pbmRleGluZyKsAQoJSW5kZXhLaW5kEjAKBGtpbmQYASABKA4yIi5keG9zLmVjaG8uaW5kZXhpbmcuSW5kZXhLaW5kLktpbmQSEgoFZmllbGQYAiABKAlIAIgBASJPCgRLaW5kEhAKDFNDSEVNQV9NQVRDSBAAEg8KC0ZJRUxEX01BVENIEAESDQoJRlVMTF9URVhUEAISCgoGVkVDVE9SEAMSCQoFR1JBUEgQBEIICgZfZmllbGQiXwoLSW5kZXhDb25maWcSLgoHaW5kZXhlcxgBIAMoCzIdLmR4b3MuZWNoby5pbmRleGluZy5JbmRleEtpbmQSFAoHZW5hYmxlZBgCIAEoCEgAiAEBQgoKCF9lbmFibGVkYgZwcm90bzM");
/**
 * Describes the message dxos.echo.indexing.IndexKind.
 * Use `create(IndexKindSchema)` to create a new message.
 */
export const IndexKindSchema = /*@__PURE__*/ messageDesc(file_dxos_echo_indexing, 0);
/**
 * @generated from enum dxos.echo.indexing.IndexKind.Kind
 */
export var IndexKind_Kind;
(function (IndexKind_Kind) {
    /**
     * / Match by typename.
     *
     * @generated from enum value: SCHEMA_MATCH = 0;
     */
    IndexKind_Kind[IndexKind_Kind["SCHEMA_MATCH"] = 0] = "SCHEMA_MATCH";
    /**
     * / Match by field value.
     *
     * @generated from enum value: FIELD_MATCH = 1;
     */
    IndexKind_Kind[IndexKind_Kind["FIELD_MATCH"] = 1] = "FIELD_MATCH";
    /**
     * / Match by full text.
     *
     * @generated from enum value: FULL_TEXT = 2;
     */
    IndexKind_Kind[IndexKind_Kind["FULL_TEXT"] = 2] = "FULL_TEXT";
    /**
     * / Match by vector.
     *
     * @generated from enum value: VECTOR = 3;
     */
    IndexKind_Kind[IndexKind_Kind["VECTOR"] = 3] = "VECTOR";
    /**
     * / Match by graph relationships.
     *
     * @generated from enum value: GRAPH = 4;
     */
    IndexKind_Kind[IndexKind_Kind["GRAPH"] = 4] = "GRAPH";
})(IndexKind_Kind || (IndexKind_Kind = {}));
/**
 * Describes the enum dxos.echo.indexing.IndexKind.Kind.
 */
export const IndexKind_KindSchema = /*@__PURE__*/ enumDesc(file_dxos_echo_indexing, 0, 0);
/**
 * Describes the message dxos.echo.indexing.IndexConfig.
 * Use `create(IndexConfigSchema)` to create a new message.
 */
export const IndexConfigSchema = /*@__PURE__*/ messageDesc(file_dxos_echo_indexing, 1);
//# sourceMappingURL=indexing_pb.js.map